"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildParamUrl = buildParamUrl;
exports.isValidUrl = isValidUrl;
exports.getUrlPath = getUrlPath;
exports.encodeURIComponentEachSubdomain = encodeURIComponentEachSubdomain;
exports.encodeURIComponentCCStorageUrl = encodeURIComponentCCStorageUrl;
exports.getUrn = getUrn;
exports.responseHandler = responseHandler;
exports.InstanceCreator = InstanceCreator;

require("url-polyfill");

var _lodash = _interopRequireDefault(require("lodash.size"));

/**
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2018 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 */

/**
 * buildParamUrl - recursive method for building a get url from a key value paired object.
 * @example params = { name : 'Bob', value : 'person', key : 'test' }
 * @param {Object} params - key values or get request
 * @returns {String} - name=Bob&value=person&key=test i.e. example param above
 */
function buildParamUrl(params) {
  if ((0, _lodash["default"])(params) > 0) {
    var url = new URLSearchParams(params);
    return url.toString();
  }

  return '';
}
/**
 * isValidUrl - url validator regex
 * @param  {String} [value=''] - string to test if is in correct formate
 * @return {Boolean}           - result of check
 */


function isValidUrl() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  // eslint-disable-next-line no-useless-escape
  return /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_ ]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/.test(value);
}
/**
 * getUrlPath - get the URL path without the host name. e.g. 'http://www.adobe.com/this/is/the/path#$%^' will return 'this/is/the/path#$%^'
 * @param  {String} [value=''] - url string to extract the path from
 * @return {String}            - the path of the url string. If the passed in string is not a valid url, the same string will be returned.
 */


function getUrlPath(value) {
  if (isValidUrl(value)) {
    var origin = new URL(value).origin; // Gets the `http://www.adobe.com` part

    var urlPath = value.substring(origin.length); // urlPath is the rest, including any special characters. i.e. /this/is/the/path#$%^

    return urlPath.charAt(0) === '/' ? urlPath.substring(1) : urlPath;
  }

  return value;
}
/**
 * encodeURIComponentEachSubdomain
 * @param  {String} value - string to encode
 * @return {String} - that has encodeURIComponent but leaving the '/' intact
 */


function encodeURIComponentEachSubdomain(value) {
  if (value) {
    return value.split('/').map(encodeURIComponent).join('/');
  }

  return value;
}
/**
 * encodeURIComponentCCStorageUrl
 * @param  {String} value - string to encode
 * @return {String} - that is encoded safely to be put into the body
 */


function encodeURIComponentCCStorageUrl(value) {
  if (isValidUrl(value)) {
    var origin = new URL(value).origin; // Gets the `http://www.adobe.com` part

    var urlPath = value.substring(origin.length); // gets the rest

    return "".concat(origin).concat(encodeURIComponentEachSubdomain(urlPath));
  }

  return value;
}
/**
 * getUrn - get the URN part of a url
 * @param  {String} [value=''] - url string to extract the urn from
 * @return {String}            - the urn suffix
 */


function getUrn() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return isValidUrl(value) && value.indexOf('urn:') > -1 ? value.substring(value.indexOf('urn:')) : null;
}
/**
 * responseHandler - handles normalizing response based on status number
 * @param  {Response} response - raw fetch response object, will be normalized and return in all cases except 500.
 * @return {?Object}          [description]
 */


function responseHandler(response) {
  if (response.status === 500) {
    return Promise.reject({
      error: response,
      status: 500
    });
  }

  return response.json();
}
/**
 * @param  {Class} ServiceClass - Class to be created and returned.
 * @param  {Object} InstanceConfig - reference to module instance singlton and params;
 * @return {Function} - function used for getting instance of singleton or new class instance
 */


function InstanceCreator(ServiceClass, InstanceConfig) {
  function Instance(params) {
    // RETURN SINGLETON
    var instance = InstanceConfig.instance,
        instanceParams = InstanceConfig.params;

    if (!params && instance) {
      return instance;
    } // RETURN NEW INSTANCE IF WAS CALLED WITH NEW PARAMS


    if (params && instance) {
      InstanceConfig.params = params;
      InstanceConfig.instance = new ServiceClass(params);
      return InstanceConfig.instance;
    }

    if (!instanceParams && !params) {
      throw new Error('Service Class is not configured.');
    }

    InstanceConfig.params = params || instanceParams;
    InstanceConfig.instance = new ServiceClass(InstanceConfig.params);
    return InstanceConfig.instance;
  } // ONLY CALL CONFIGURE IF YOU WANT A SINGLETON RETURNED


  Instance.configure = function configure(params) {
    InstanceConfig.params = params;
  };

  return Instance;
}